import React, { lazy, Suspense, useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import './App.css';

const About = lazy(() => import('./pages/About'));
const Services = lazy(() => import('./pages/Services'));
const Fleet = lazy(() => import('./pages/Fleet'));
const Coverage = lazy(() => import('./pages/Coverage'));
const Contact = lazy(() => import('./pages/Contact'));
const Footer = lazy(() => import('./components/Footer'));
const StickyCallButton = lazy(() => import('./components/StickyCallButton'));

function App() {
  const [showDeferredLayout, setShowDeferredLayout] = useState(false);

  useEffect(() => {
    setShowDeferredLayout(true);
  }, []);

  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <ScrollToTop />
          <Header />
          <Suspense fallback={null}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/fleet" element={<Fleet />} />
              <Route path="/coverage" element={<Coverage />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </Suspense>
          {showDeferredLayout && (
            <Suspense fallback={null}>
              <Footer />
              <StickyCallButton />
            </Suspense>
          )}
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
